export const STORAGE_KEYS = {
  profile: 'snakegame.profile',
  session: 'snakegame.session',
  preferences: 'snakegame.preferences',
  leaderboard: 'snakegame.leaderboard'
} as const;

export function readStorage<T>(key: string, fallback: T): T {
  if (typeof window === 'undefined') {
    return fallback;
  }

  try {
    const rawValue = window.localStorage.getItem(key);

    if (!rawValue) {
      return fallback;
    }

    return JSON.parse(rawValue) as T;
  } catch (error) {
    console.warn(`Unable to parse local storage for ${key}`, error);
    return fallback;
  }
}

export function writeStorage<T>(key: string, value: T): void {
  if (typeof window === 'undefined') {
    return;
  }

  try {
    window.localStorage.setItem(key, JSON.stringify(value));
  } catch (error) {
    console.warn(`Unable to write local storage for ${key}`, error);
  }
}
